import React, { useEffect, useRef } from 'react';
import ApexCharts from 'apexcharts';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types'; // Import PropTypes

const RadialChartServices = ({ data }) => {
    const chartRef = useRef(null);
    const PendingServiceRequest = parseFloat(data.PendingServiceRequest) || 0;
    const CompletedServiceRequest = parseFloat(data.CompletedServiceRequest) || 0;
    const theme = useTheme(); 

    useEffect(() => {
        const options = {
            chart: {
                type: 'donut',
                width: 300,
                redrawOnParentResize: true,
            },
            series: [PendingServiceRequest, CompletedServiceRequest],
            labels: ['Open', 'Closed'],
            colors: ['#9B134A', 'rgb(185, 80, 71)'], 
            dataLabels: {
                enabled: true,
                formatter: (val, opts) => {
                    return `${opts.w.globals.series[opts.seriesIndex]}`;
                },
                style: {
                    colors: ['white'],
                    fontSize: '14px',
                    fontWeight: 'bold',
                },
                dropShadow: {
                    enabled: true,
                },
                position: 'inside', 
                offsetX: 0,
                offsetY: 0,
                textAnchor: 'middle',
            },
            tooltip: {
                enabled: false, 
            },
            plotOptions: {
                pie: {
                    expandOnClick: false,
                },
            },
            legend: {
                labels: {
                    colors: [theme.palette.text.primary], 
                },
            },
            responsive: [
                {
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 320,
                        },
                        legend: {
                            position: 'bottom',
                            labels: {
                                colors: [theme.palette.text.primary], 
                            },
                        },
                    },
                },
            ],
        };

        const chart = new ApexCharts(chartRef.current, options);
        chart.render();


        const overrideLabelColors = () => {
            const labels = chartRef.current.querySelectorAll('.apexcharts-legend-text');
            labels.forEach((label) => {
                label.style.color = theme.palette.text.primary; 
            });
        };


        overrideLabelColors();

        return () => {
            chart.destroy();
        };
    }, [CompletedServiceRequest, PendingServiceRequest, theme]); 

    return <div ref={chartRef} className="changeGraph" />;
};

 // PropTypes validation
 RadialChartServices.propTypes = {
        data: PropTypes.shape({
            PendingServiceRequest: PropTypes.number,
            CompletedServiceRequest: PropTypes.number,
        }).isRequired,
    };


export default RadialChartServices;